import { Card } from "@/components/ui/card";
import checoThumbnail from "@/assets/checo-thumbnail.webp";
import stacheBarbersLogo from "@/assets/stache-barbers-logo.webp";
import {
  Attribution,
  QuoteCard,
  VideoThumbOverlay,
} from "./testimonial/shared";
import { StacheBarbersVisual } from "./testimonial/StacheBarbersVisual";

export function TestimonialFeatureSectionFour() {
  return (
    <section className="bg-background pt-12 pb-0 sm:pt-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="h-px w-full bg-gradient-to-r from-transparent via-foreground/15 to-transparent" />
      </div>
      <div className="mx-auto mt-12 max-w-7xl px-6 sm:mt-16 lg:px-10">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
          {/* Left: animated Stache Barbers landing page with video thumbnail overlay */}
          <Card className="relative order-2 mx-auto w-full border-border/60 bg-card/60 p-0 backdrop-blur lg:order-1">
            <div className="relative w-full">
              <StacheBarbersVisual />
              {/* VideoThumbOverlay removed until video is provided */}
            </div>
          </Card>

          {/* Right: headline + quote + attribution */}
          <div className="order-1 flex flex-col lg:order-2">

            <div className="flex items-center gap-6">
              <h2 className="text-[1.75rem] sm:text-4xl font-bold tracking-tight text-foreground">
                <span className="lg:hidden">15 minutes in, I knew<br />exactly what I was{" "}<span className="text-gradient-cycle">getting.</span></span>
                <span className="hidden lg:inline">15 minutes in, I knew<br />exactly what I was <span className="text-gradient-cycle">getting.</span></span>
              </h2>
            </div>

            <QuoteCard>
              I almost didn&rsquo;t book because I hate sales calls, but they
              asked smart questions and I left the call feeling like they{" "}
              <span className="text-gradient-cycle font-bold">
                got my vision.
              </span>
            </QuoteCard>

            <Attribution
              avatarSrc={checoThumbnail}
              avatarAlt="Michael Checo"
              name="Michael Checo"
              role="Owner, Stache Barbers"
              logoSrc={stacheBarbersLogo}
              logoAlt="Stache Barbers logo"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
